// extracted by css-extract-rspack-plugin
export default {"icon":"_93523fc0"};